// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { baseGoerli as _baseGoerli } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the baseGoerli chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 84531
 * Chain Name: Base Goerli
 * Default Block Explorer: https://goerli.basescan.org
 * Default RPC URL: https://goerli.base.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { baseGoerli } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: baseGoerli,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const baseGoerli = createCommon({
	..._baseGoerli,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
